import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  patientId: yup.number().required(),
});

const responseSchema = yup.object({
  all: yup.number().required(),
  read: yup.number().required(),
  unread: yup.number().required(),
});

export const usePatientSmsCountQuery = (payload = {}, options = {}) => {
  return useQuery(
    [QUERY_KEYS.patient.smsCount, payload.patientId],
    async () => {
      const req = requestSchema.validateSync(payload, { strict: true });
      const res = await http.get(
        HTTP_ENDPOINTS.patient.getSmsCount(req.patientId),
      );
      return responseSchema.validateSync(res?.data?.data, {
        strict: true,
      });
    },
    options,
  );
};
